import React from 'react'
import { SvgIconProps } from './VesselIcon'

/**
 *
 * @param color represents the color of the SVG icon.
 * The path in this svg is similar to path in "public/assets/images/icons/location-icon.svg"
 * @returns
 */
const LocationMarker: React.FC<SvgIconProps> = ({ color }) => {
    return (
        <svg
            width="24"
            height="26"
            viewBox="0 0 24 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="vuesax/bold/location">
                <path
                    id="Vector"
                    d="M20.62 8.45C19.57 3.83 15.54 1.75 12 1.75C12 1.75 12 1.75 11.99 1.75C8.46001 1.75 4.42001 3.82 3.37001 8.44C2.20001 13.6 7.43999 19.44 8.22001 20.72C9.00004 22 12 25.5 12 25.5C12 25.5 14.5 22.5 15.77 20.72C17.04 18.94 21.79 13.61 20.62 8.45ZM12 13.46C10.26 13.46 8.85001 12.05 8.85001 10.31C8.85001 8.57 10.26 7.16 12 7.16C13.74 7.16 15.15 8.57 15.15 10.31C15.15 12.05 13.74 13.46 12 13.46Z"
                    fill={color}
                />
            </g>
        </svg>
    )
}

export default LocationMarker
